import { RemoveGlobalAdminModal} from "./RemoveGlobalAdminModal";

export default RemoveGlobalAdminModal;
